import { City } from "./city";
import { CustomerClass } from "./customer-class";
import { CustomerDeliveryDetails } from "./customer-delivery-details";
import { State } from "./state";


export class Customer {
    refNo: string;
    customerName: string;
    customerMobile: string;
    customerGstin: string;
    customerEmail: string;
    customerDob: Date;
    customerSpouseName: string;
    customerSpouseDob: Date;
    customerAnniversaryDate: Date;
    customerCreditLimit: any;
    customerOpeningBalance: any;
    customerOpeningBalanceType: string;
    customerClassCode: number;
    stateCode: number;
    state: State;
    customerClass: CustomerClass;
    customerDeliveryDetails: CustomerDeliveryDetails[] = [];

    //For Import
    customerGstIn: string;
    customerClassName: string;
    stateName: string;

    customerBillingAddress: string;
    billingCityCode: number;
    billingStreet: string;
    billingLandMark: string;
    billingPlotNo: string;
    billingPinCode: string;

    billingCity: City;
    billingDistrictCode: number;

    deliveryAddressRefNo: number;

    moduleName: string;
    waVarified: boolean;
    fromLocationCode: number;
    locationCode: number;
    companyCode: number;

}
